import { FirebaseError } from 'firebase/app';
import { UserCredential } from 'firebase/auth';

export enum AuthCode {
  success = 'success',
  failure = 'failure',
  unknown = 'unknown',
  codeInvalid = 'codeInvalid',
  tooManyRequest = 'tooManyRequest',
}

export interface AuthResult {
  code: AuthCode;
  userCredential?: UserCredential;
  error?: FirebaseError;
}
